import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useInitializeUserPaymentMethodPayPalSetupQuery = createQueryHook(
  PaymentApiClient.initializeUserPaymentMethodPayPalSetup,
  {
    queryKey: ['initializeUserPaymentMethodPayPalSetup'],
  },
)
